import P from "prop-types";

import { useState } from "react";
import { Apresentacao } from "./Apresentacao";
import { Casos } from "./Casos";
import { Internacoes } from "./Internacoes";
import { Obitos } from "./Obitos";
import { TabMenuArea } from "./TabMenuArea";

const PainelCovid = ({ hidden }) => {
  const [index, setIndex] = useState(1);
  const [queryState, setQueryState] = useState("all");

  if (hidden) {
    return <></>;
  } else
    return (
      <>
        <Apresentacao queryState={queryState} setState={setQueryState} />
        <TabMenuArea index={index} setIndex={setIndex} />
        <Casos hidden={index !== 1} queryState={queryState} />
        <Internacoes hidden={index !== 2} queryState={queryState} />
        <Obitos hidden={index !== 3} queryState={queryState} />
      </>
    );
};

export default PainelCovid;

PainelCovid.propTypes = {
  hidden: P.bool.isRequired,
};
